module.exports = __webpack_public_path__ + "img/104.bbc4bf2a.svg";